import { render } from "./ProdBrandViewPage.vue?vue&type=template&id=490a8b5c&ts=true"
import script from "./ProdBrandViewPage.vue?vue&type=script&lang=ts"
export * from "./ProdBrandViewPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__